import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'REQUEST_SCOREBOARD_INFORMATION',
    'SET_SCOREBOARD_INFORMATION',
], 'SMARTGUARD');

// Action Creators
export const requestScoreboardInformation = createAction(actions.REQUEST_SCOREBOARD_INFORMATION);
export const setScoreboardInformation = createAction(actions.SET_SCOREBOARD_INFORMATION);

// Reducers
const initialState = {
    scoreboard: null
};

export default handleActions({
    [actions.SET_SCOREBOARD_INFORMATION]: (state, action) => update(state, {
        scoreboard: {
            $set: action.payload
        }
    })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/smartguard/duck.js